import { Input, Modal, Select, message } from "antd";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { postBlogs, updateBlogs } from "../../redux/actions/blogAction";
import { getTags, uGetTags } from "../../redux/actions/tagAction";
import "../../styles/createBlog.scss";
import { getTagsAPI } from "../../api/GetTags";
import { useAuthStore } from "../../store/AuthStore";
import { queryClient } from "../../index";
import { createBlogAPI, updateBlogAPI } from "../../api/GetBlogs";
import { useMutation } from "@tanstack/react-query";

const { TextArea } = Input;

const CreateBlog = (props) => {
  const { setAuthData } = useAuthStore();

  const { blog } = props;
  const { isLoggedIn } = useSelector((state) => state.auth);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [selectedTags, setSelectedTags] = useState([]); //will be populated for edit
  const [searchedTags, setSearchedTags] = useState([]); //for search

  useEffect(() => {
    if (blog) {
      setSelectedTags(blog.tags);
      setSearchedTags(blog.tags);
      setTitle(blog.title);
      setDescription(blog.description);
    }
  }, [blog]);

  const { mutate: createBlog } = useMutation({
    mutationFn: (body) => createBlogAPI(body),
    onSuccess: (res) => {
      message.success("Blog Created Successfully");
      props.setShow(false);
      queryClient.invalidateQueries();

      setAuthData({
        blogData: res.data.data,
        mainBlogId: res.data.data.id,
        hasBlog: true,
        isLoggedIn: true,
      });
    },
  });

  const { mutate: updateBlog } = useMutation({
    mutationFn: (body) => updateBlogAPI(body),
    onSuccess: () => {
      message.success("Blog Updated Successfully");
      props.setShow(false);
      queryClient.invalidateQueries();
    },
  });

  const handleSubmit = () => {
    //Remove duplicate tags
    let tagObjects = [];
    tagObjects = selectedTags
      .map((tag) => tag.id)
      .reduce((a, b) => {
        if (a.indexOf(b) < 0) a.push(b);
        return a;
      }, []);

    const body = {
      title,
      description,
      blogTagIds: tagObjects,
      urlSlug: title
        .trim()
        .toLowerCase()
        .replace(/[^a-zA-Z ]/g, "_")
        .replace(/ /g, "_")
        .trim()
        .replace(/_+$/g, "")
        .replace(/_+/g, "_"),
    };

    if (blog) {
      updateBlog({
        blogId: blog.id,
        body: body,
      });
    } else {
      createBlog(body);
    }
  };

  //Fetch Tags
  const handleSearchTags = async (search) => {
    if (isLoggedIn) {
      getTagsAPI(10, 1, "speciality", "", search).then(({ tags }) => {
        setSearchedTags((prev) => [...prev, ...tags]);
      });
    }
  };

  const handleDisplayTags = (arrOfIds) => {
    let currentlySelected = selectedTags;

    arrOfIds.forEach((id) => {
      searchedTags.forEach((tag) => {
        if (tag.id == id) {
          currentlySelected.push(tag);
        }
      });
    });

    setSelectedTags(currentlySelected);
  };

  const handleRemoveTag = (id) => {
    setSelectedTags(selectedTags.filter((tag) => tag.id != id));
  };

  return (
    <React.Fragment>
      <Modal
        centered
        width={850}
        open={props.show}
        closable={false}
        footer={null}
        className="blog-modal"
      >
        <h2 className="blog-information">Blog Information</h2>
        <button onClick={() => props.setShow(false)} className="cross">
          &times;
        </button>
        <p className="subtitle">
          Choose a name for your blog and the specialties associated with it.
        </p>

        <Input
          // showCount
          maxLength={30}
          className="blog-input"
          id="blogname"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="BLOG TITLE"
        />
        <div
          className="d-flex text-muted justify-content-between mb-6"
          style={{ fontSize: "14px" }}
        >
          <p>This is the name of your blog, do not confuse with post title.</p>
          <p className="title-length"> {title.length} / 30</p>
        </div>

        <Select
          mode="multiple"
          showArrow={true}
          style={{ width: "100%" }}
          placeholder="SPECIALITIES"
          className="blog-select"
          defaultValue={selectedTags.map((tag) => tag.id)}
          onDeselect={handleRemoveTag}
          onChange={handleDisplayTags}
          onSearch={(s) => handleSearchTags(s)}
          filterOption={false}
          options={searchedTags.map((tag) => ({
            value: tag.id,
            label: tag.name,
          }))}
        />

        <TextArea
          style={{ width: "100%", margin: "20px 0" }}
          showCount
          maxLength={5000}
          rows="10"
          className="text-area"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          id="blogname"
          placeholder="Please briefly describe your blog here - the range of medical and health topics you
            plan to cover, your experiences, research interests, and accomplishments, etc. This description may help
            individuals seeking reliable healthcare information and guidance."
        />

        <div className="text-right pt-6">
          <button
            onClick={() => props.setShow(false)}
            className="uppercase font-bold mr-6"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="btn-custom-sm bg-blue-600 hover:bg-blue-700 text-white font-bold uppercase rounded-full"
          >
            {props.blog?.id ? "UPDATE" : "CREATE"}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  tags: state.tag.tags,
});

export default connect(mapStateToProps, {
  getTags,
  postBlogs,
  updateBlogs,
  uGetTags,
})(CreateBlog);
